import { EPaymentMethod, getEPaymentMethodList } from '@if/core/types'
import * as yup from '@if/core/yup'

export const merchantPaymentSchema = yup.object({
  merchantId: yup.string().required(),
  amount: yup.double().positive().required(),
  paymentMethod: yup
    .mixed<EPaymentMethod>()
    .oneOf(getEPaymentMethodList())
    .default(EPaymentMethod.BankTransfer)
    .required(),
})

export interface MerchantPayment {
  merchantId: string
  amount: number
  paymentMethod: EPaymentMethod
  merchantName?: string
}
